import { type SVGProps } from 'react';

export const DEFAULT_SIZE = 24;

export type IconProps = SVGProps<SVGSVGElement> & {
	size?: number;
	color?: string;
};
